'use strict';

var tracking = require('dibs-tracking');
var dataProvider = require('bunsen/helpers/dataProvider');
var parseFloat = require('dibs-currency-helpers/util').parseFloat;
var purchaseTracking = require('../../../global/mixins/purchaseTracking.es');
var carouselHelpers = require('../../helpers/carouselHelpers.es');

// Pulled from `PdpPrice`. This should really be extracted somewhere more easily accessible.
function getTrackingData() {
    var price = dataProvider.get('tracking.initialDataLayerInfo.askingPrice');
    return {
        brand: dataProvider.get('data.dealerPk'),
        name: dataProvider.get('data.titleCondensed'),
        price: parseFloat(price),
        url: dataProvider.get('data.canonicalUrl') || document.URL,
    };
}

function ModalCarouselTracking(options) {
    this._category = carouselHelpers.getCarouselCategory(options.owner);
    this._imageslength = options.imagesLength;
    this._item = options.item;
}

ModalCarouselTracking.prototype.purchase = function purchase() {
    purchaseTracking.firePurchaseButtonTracking(
        this._item,
        undefined,
        'image zoom modal purchase button'
    );
    purchaseTracking.ecommerceAddToCartTracking(getTrackingData());
};

ModalCarouselTracking.prototype.showModal = function showModal(index) {
    tracking.trackEvent({
        category: this._category,
        action: 'primary image click',
        label: index + 1 + '/' + this._imageslength,
    });
};

ModalCarouselTracking.prototype.thumbnailClick = function thumbnailClick(index) {
    tracking.trackEvent({
        category: this._category,
        action: 'image zoom modal thumbnail click',
        label: index + 1 + '/' + this._imageslength,
    });
};

ModalCarouselTracking.prototype.previousClick = function previousClick(index) {
    tracking.trackEvent({
        category: this._category,
        action: 'image zoom modal previous button',
        label: index + 1 + '/' + this._imageslength,
    });
};

ModalCarouselTracking.prototype.nextClick = function nextClick(index) {
    tracking.trackEvent({
        category: this._category,
        action: 'image zoom modal next button',
        label: index + 1 + '/' + this._imageslength,
    });
};

module.exports = ModalCarouselTracking;



//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Carousel/ModalCarouselTracking.js
// module id = 3412
// module chunks = 4